// extracted by mini-css-extract-plugin
export default {"expanded":"style_expanded__3nBHY"};